import { render, staticRenderFns } from "./SubscriptionDetail.vue?vue&type=template&id=f31d8982&scoped=true&"
import script from "./SubscriptionDetail.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionDetail.vue?vue&type=style&index=0&id=f31d8982&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31d8982",
  null
  
)

export default component.exports